module.exports = __webpack_public_path__ + "media/E7.b5abbaef.wav";